import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdminman = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.342,
	height: 14.654,
	viewBox: "0 0 13.342 14.654",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_2677",
		"data-name": "Group 2677",
		transform: "translate(-501.486 -106.673)",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_123",
			"data-name": "Ellipse 123",
			cx: 3.274,
			cy: 3.274,
			r: 3.274,
			transform: "translate(504.888 107.573)",
			fill: "current",
			stroke: "current",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			strokeWidth: 1.8
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_382",
			"data-name": "Path 382",
			d: "M2973.6,1663.081a3.6,3.6,0,0,0-3.494-2.741h-4.367a3.6,3.6,0,0,0-3.51,2.811,7.76,7.76,0,0,0,11.371-.07Z",
			transform: "translate(-2459.76 -1545.168)",
			fill: "current",
			stroke: "current",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			strokeWidth: 1.8
		})]
	})]
});
const ForwardRef = forwardRef(SvgAdminman);
export { ForwardRef as ReactComponent };
